import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { ExperiNavState } from "API/navExperiment";

interface NavBarProps {
    mark: number;
    onChange: (val: number) => void;
}

export default function NavBar({ mark, onChange }: NavBarProps) {
    return (
        <div className={style.root}>
            <div className={style.links}>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === ExperiNavState.introduction
                    })}
                    onClick={() => onChange(ExperiNavState.introduction)}>
                    项目介绍
                </div>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === ExperiNavState.software
                    })}
                    onClick={() => onChange(ExperiNavState.software)}>
                    安装软件
                </div>
                <div
                    className={classNames(style.link, {
                        [style.current]: mark === ExperiNavState.planList
                    })}
                    onClick={() => onChange(ExperiNavState.planList)}>
                    预约计划
                </div>
            </div>
        </div>
    );
}
